export const LIST_OF_LOCATIONS = {
  AUTOCOMPLETE_PLACEHOLDER: 'Find by location',
  SEARCH_DROPDOWN_EMPTY_VALUE: 'Location was not found...',
  BUTTON_LABEL: 'Add location',
  TOOLTIP_CONTENT:
    'Here you can add information about the locations where you provide car rental services.',
  MISSING_FIELDS_MESSAGE:
    'Fill in the missing information on the locations marked with an icon',
  CHECKBOX_LABEL: 'Show only locations required to fill in',
}

export const AVAILABLE_VEHICLES_MODAL = {
  TITLE: 'List of car models',
  ALL: 'All',
  SELECTED: 'Selected: ',
  CARS: ' cars',
  BUTTON_LABEL: 'Save',
}

export const AVAILABLE_EQUIPMENTS_MODAL = {
  TITLE: 'List of equipment',
  ALL: 'All',
  SELECTED: 'Selected: ',
  EQUIPMENTS: ' equipments',
  BUTTON_LABEL: 'Save',
}

export const DELETE_LOCATION_MODAL = {
  DELETE: 'Delete',
  CANCEL: 'Cancel',
  DEACTIVATE: 'Deactivate',
  ACTIVATE: 'Activate',
  CONFIRM: 'Confirm',
  CONFIRM_QUESTION: (
    locationName: string
  ) => `Are you sure that you want to delete ${locationName}
   location?`,
}
